
export interface User {
  id: string;
  username: string,
  name: string,
  companyId: string,
  role: UserRoles,
  isActive: boolean,
  isEmailConfirmed: boolean
}

export enum UserRoles {
  XvivoAdmin = 'XVIVO Admin',
  XvivoSupport = 'XVIVO Technical Support',
  Admin = 'System Manager',
  User = 'System User',
  ViewerPlus = 'Viewer Premium',
  Viewer = 'Viewer',
}

export enum AddNewViewerRoles {
  ViewerPlus = 'Viewer Premium',
  Viewer = 'Viewer',
}


export interface UserRights {
  updateDeviceName: boolean,
  linkUnlinkHa: boolean,
  downloadVideo: boolean,
  exportData: boolean,
  requestRunDelete: boolean,
  toggleSupportAccess: boolean,
  manageRunViewers: boolean,

  manage: boolean,
  manageCompanies: boolean,
  managePartners: boolean,
  manageUsers: boolean,
  manageViewers: boolean,
  manageDeleteRequests: boolean,
  manageContent: boolean
}